// TennisTrack Hub — Auth Context | 029 Project
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
const APP_API_KEY = process.env.REACT_APP_API_KEY;

// Imposta X-App-Key come header di default su tutte le chiamate axios globali
if (APP_API_KEY) {
  axios.defaults.headers.common['X-App-Key'] = APP_API_KEY;
}

export const AuthProvider = ({ children }) => {
  const [utente, setUtente] = useState(null);
  const [loading, setLoading] = useState(true);

  // Carica utente al mount se c'è un token salvato
  useEffect(() => {
    const token = localStorage.getItem('tt_token');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      axios.get(`${API_URL}/auth/me`)
        .then(res => setUtente(res.data.utente))
        .catch(() => {
          localStorage.removeItem('tt_token');
          delete axios.defaults.headers.common['Authorization'];
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await axios.post(`${API_URL}/auth/login`, { email, password });
    const { token, utente } = res.data;
    localStorage.setItem('tt_token', token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUtente(utente);
    return utente;
  };

  const register = async (nome, cognome, email, password) => {
    const res = await axios.post(`${API_URL}/auth/register`, { nome, cognome, email, password });
    const { token, utente } = res.data;
    localStorage.setItem('tt_token', token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUtente(utente);
    return utente;
  };

  const logout = () => {
    localStorage.removeItem('tt_token');
    delete axios.defaults.headers.common['Authorization'];
    setUtente(null);
  };

  // loginDaToken: usato da Google OAuth dopo che il backend restituisce token+utente
  const loginDaToken = (token, utenteData) => {
    localStorage.setItem('tt_token', token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUtente(utenteData);
  };

  return (
    <AuthContext.Provider value={{ utente, loading, login, register, logout, loginDaToken }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth deve essere usato dentro AuthProvider');
  return ctx;
};
